export default {
  users: [],
  meta: null,
  links: null,
  loading: false,
  error: null,
  tasks_coming_up: [],
  profile: null,
};
